/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-extraneous-dependencies */
import { useNamespace, useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

function useCustomFields(customFieldId) {
  const okapiKy = useOkapiKy();
  const [namespace] = useNamespace({ key: 'customFields' });

  const {
    isLoading,
    isError,
    data = {},
    refetch,
    ...rest
  } = useQuery(
    [namespace, customFieldId],
    () =>
      okapiKy
        .get(
          customFieldId
            ? `inventory-customFields/${customFieldId}`
            : 'inventory-customFields?limit=2147483647',
        )
        .json(),
    { enabled: customFieldId ? Boolean(customFieldId) : true },
  );

  return {
    isLoading,
    isError,
    customFields: customFieldId ? data : data.customFields,
    refetch,
    rest,
  };
}

export default useCustomFields;
